import React from 'react';
import { Flex } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

interface ValueWithChangeProps {
  value?: number | string;
  unit?: string;
  change?: number;
  is_negative?: boolean;
  showChangeText?: boolean;
}

const ValueWithChange: React.FC<ValueWithChangeProps> = ({
  value,
  unit,
  change,
  is_negative,
  showChangeText = false,
}) => {
  return (
    <Flex gap={4}>
      <div className='zl-heading-32'>
        {value ?? '--'}
        {unit && value ? <span> {unit}</span> : null}
      </div>

      {value && change ? (
        <div
          className={`sentiment-change ${is_negative ? 'nagtive' : 'positive'}`}
        >
          {is_negative ? <ArrowDownOutlined /> : <ArrowUpOutlined />}
          {Math.abs(change)}%
          {showChangeText && (
            <span className='font-12 fw-400' style={{ color: '#757575' }}>
              {' '}
              change from previous period
            </span>
          )}
        </div>
      ) : (
        <Flex align='end'>---</Flex>
      )}
    </Flex>
  );
};

export default ValueWithChange;
